<template>
  <div class="confirmacio-container">
    <ion-list>
      <ion-list-header>
        <ion-label>{{ $t("bookings.summary") }}</ion-label>
      </ion-list-header>
      <div v-for="(form, index) of forms" :key="index">
        <div class="section-title" v-if="forms.length > 1">{{ $t("bookings.booking") }} {{ index + 1 }}</div>
        <ion-item>
          <ion-label>{{ $t("bookings.dates") }}</ion-label>
          <div>{{ datesLabel(form) }}</div>
        </ion-item>
        <ion-item>
          <ion-label>{{ $t("bookings.vehicle") }}</ion-label>
          <div v-for="vehicle of form.vehicles" :key="vehicle.id">
            {{ vehicle.model }}
          </div>
        </ion-item>
        <ion-item>
          <ion-label>{{ $t("bookings.fullName") }}</ion-label>
          <div>{{ form.client.client_name }}</div>
        </ion-item>
        <ion-item>
          <ion-label>{{ $t("bookings.email") }}</ion-label>
          <div>{{ form.client.client_email }}</div>
        </ion-item>
        <ion-item>
          <ion-label>{{ $t("bookings.phone") }}</ion-label>
          <div>{{ form.client.client_phone }}</div>
        </ion-item>
      </div>

      <ion-item v-if="!guest">
        <ion-label>Preu</ion-label>
        <ion-input v-model="total_price"></ion-input>
      </ion-item>
    </ion-list>
    <div style="text-align:center;">
      <ion-button color="light" @click="$emit('add')">{{ $t("bookings.addVehicleToBooking") }}</ion-button>
    </div>
  </div>
</template>

<script>
// import moment from 'moment';
import { IonList, IonItem, IonLabel, IonInput, IonButton } from "@ionic/vue";
import moment from "moment";

export default {
  props: ["form", "guest", "forms"],
  components: {
    IonList,
    IonItem,
    IonLabel,
    IonButton,
    IonInput,
    // IonCheckbox,
  },
  data() {
    return {
      vehicles: [],
      total_price: 0,
    };
  },
  watch: {
    total_price: {
      deep: false,
      handler(newVal) {
        this.$emit("update:modelValue", newVal);
      },
    },
  },
  mounted() {
    this.total_price = this.form.price.price;
  },
  methods: {
    selectVehicle(vehicle) {
      //this.$emit('vehicle', vehicle);
    },
    datesLabel(form) {
      return (
        moment(form.dates.start).format("DD/MM/YYYY HH:mm") +
        " al " +
        moment(form.dates.end).format("DD/MM/YYYY HH:mm")
      );
    },
  },
  computed: {
    dates() {
      return (
        moment(this.form.dates.start).format("DD/MM/YYYY HH:mm") +
        " al " +
        moment(this.form.dates.end).format("DD/MM/YYYY HH:mm")
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.confirmacio-container {
  margin-right: 10px;
  margin-bottom: 30px;
  //max-width: 350px;
}

.data {
  display: flex;
  margin-bottom: 10px;

  label {
    color: gray;
    flex: 1;
  }
}
.section-title {
  background: #ebebeb;
    font-weight: 500;
    padding: 10px 16px;
    position: relative;
    width: 100%;
}
</style>
